import { useEffect, useRef } from "react";

// Re-run `fn` on an interval, but only while the tab is visible.
// Also fires once when the tab regains focus, so a teammate's change
// shows up promptly without a manual refresh.
export function usePoll(fn, ms = 25000) {
  const ref = useRef(fn);
  ref.current = fn;
  useEffect(() => {
    const tick = () => {
      if (document.visibilityState === "visible") ref.current?.();
    };
    const id = setInterval(tick, ms);
    document.addEventListener("visibilitychange", tick);
    return () => {
      clearInterval(id);
      document.removeEventListener("visibilitychange", tick);
    };
  }, [ms]);
}
